import { defineMessages } from "react-intl";
export const messages = defineMessages({
    periodLimitExceededMessage: {
        id: "analytics.periodSelector.limitExceeded",
        defaultMessage: "The maximum period allowed is {maxPeriod} days. The {dateType} has been adjusted.",
    },
});
